import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleIcon, Text, Button, themeVars } from '@eds-web/react';
import { useDispatch } from 'react-redux';

import { useLogoutRedirect } from '../../hooks/useLogoutRedirect';
import { StyledGatedContent } from './AgeGated.style';
import { confirmAge } from '../../actions/account.actions';

export const InvalidGuardianInfo: React.FC = () => {
    const { t } = useTranslation();
    const { redirectToLogout } = useLogoutRedirect();
    const dispatch = useDispatch();

    const handleButtonClick = async () => {
        try {
            await dispatch(confirmAge({}) as any).unwrap();
            redirectToLogout();
        } catch (err) {
            if (
                err === 'errors.com.epicgames.common.oauth.invalid_token' // we should re-login to refresh acc token when account status is invalid
            ) {
                redirectToLogout();
            }
        }
    };

    return (
        <StyledGatedContent>
            <div className="alert-icon">
                <ExclamationCircleIcon size={64} color={'warning'} />
            </div>
            <div className="minor-content">
                <Text variant={'headingLG'}>{t('epic.esport.gated.guardian.invalid.title')}</Text>
                <Text
                    style={{ color: themeVars.color.transparent.light['065'] }}
                    variant="paragraphMD"
                >
                    {t('epic.esport.gated.guardian.invalid.desc')}
                </Text>
            </div>
            <div className="button-action">
                <Button type="button" size={'lg'} onClick={handleButtonClick}>
                    {t('epic.common.accountportal.default.sign_in')}
                </Button>
            </div>
        </StyledGatedContent>
    );
};
